import {
  countryCode,
  apiUrl,
  email,
  password,
  opeartorId
} from "../config/wapConfig";

const HEADERS = {
  Authorization: sessionStorage.getItem("authToken") || 'na',
  "Content-Type": "application/json",
  accept: "application/json",
  timezone : '+1',
  defaultlanguage : "ar"
};

const authorizationToken = () => {
  const body = {
    email: email,
    password: password,
  };
  return FETCH_PROMISE(apiUrl.AUTH, "POST", body);
};

const login = (msisdn, uuid) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    msisdn:  msisdn,
    transaction_identify: localStorage.getItem("transaction_identify"),
    device_type: "web",
    uuid: uuid,
  };
  let url = apiUrl.LOGIN;
  // url = "http://connex.bngrenew.com/protected-script.php"
  return FETCH_PROMISE(url, "POST", body);
};

const antifraudScript = () => {

  return FETCH_GET_PROMISE(apiUrl.ANTIFRAUD + "?targetedElement=cta_button");
};

const subscriberDetails = (msisdn) => {
  msisdn = countryCode.substring(1)+msisdn
  const url = apiUrl.SUBSCRIBER_DETAILS + `?msisdn=${msisdn}`;
  return FETCH_GET_PROMISE(url);
};

const subscriberTransactions = (msisdn) => {
  msisdn = countryCode.substring(1)+msisdn
  const url = apiUrl.SUBSCRIBER_TRANSACTIONS + `?msisdn=${msisdn}`;
  return FETCH_GET_PROMISE(url);
};

const subscriptionActivation = (msisdn, uuid) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    msisdn: msisdn,
    uuid: uuid,
    transaction_identify: localStorage.getItem("transaction_identify"),
  };
  return FETCH_PROMISE(apiUrl.SUBS_ACTIVATION, "POST", body);
};

const subscriptionActivationConFirm = (msisdn,otp, uuid) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    msisdn: msisdn,
    otp: otp,
    device_type : "web",
    uuid: uuid,
    transaction_identify: localStorage.getItem("transaction_identify"),
  };
  return FETCH_PROMISE(apiUrl.SUBS_ACTIVATE_CONFIRM, "POST", body);
};

const unsubscribe = (msisdn) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    msisdn: msisdn,
  };
  
  return FETCH_PROMISE(apiUrl.UNSUBSCRIBE, "POST", body);
};

const unsubscribeConfirm = (msisdn, otp, uuid) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    msisdn: msisdn,
    otp: otp,
    device_type: "web",
    uuid: uuid,
  };
  return FETCH_PROMISE(apiUrl.UNSUB_CONFIRM, "POST", body);
};

const upgrade = (msisdn, uuid) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    msisdn: msisdn,
    uuid: uuid,
  };
  return FETCH_PROMISE(apiUrl.UPGRADE, "POST", body);
};

const upgradeConfirm = (msisdn, uuid, otp) => {
   msisdn = countryCode.substring(1)+msisdn
  const body = {
    msisdn: msisdn,
    uuid: uuid,
    otp: otp,
    device_type :"android"
  };
  return FETCH_PROMISE(apiUrl.UPGRADE_CONFIRM, "POST", body);
};

const loginConfirm = (msisdn, otp, uuid) => {
  msisdn = countryCode.substring(1)+msisdn
 const body = {
   msisdn: msisdn,
   otp: otp,
   device_type: "web",
   uuid: uuid,
   transaction_identify: localStorage.getItem("transaction_identify"),
 };
 return FETCH_PROMISE(apiUrl.LOGIN_CONFIRM, "POST", body);
};

const subscriptionList = (msisdn) => {
  msisdn = countryCode.substring(1)+msisdn
  const url = apiUrl.SUBS_LIST + `?msisdn=${msisdn}`;
  return FETCH_GET_PROMISE(url);
};

const checkSubcription = (msisdn) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    operatorId: opeartorId,
    userId: msisdn,
  };
  const url = apiUrl.CHECKSUB ;
  return FETCH_PROMISE(url, "POST", body);
}
const subscribe = (msisdn, packtype) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    operatorId: opeartorId,
    userId: msisdn,
    packtype: packtype
  };
  const url = apiUrl.SUBSCRIBE ;
  return FETCH_PROMISE(url, "POST", body);
}

const register = (msisdn) => {
  msisdn = countryCode.substring(1)+msisdn
  const body = {
    operatorId: opeartorId,
    userId: msisdn,
  };
  const url = apiUrl.REGISTER ;
  return FETCH_PROMISE(url, "POST", body);
}

function FETCH_PROMISE(url, method = "POST", body = null) {
  const HEADERS = {
    Authorization: sessionStorage.getItem("authToken") || 'na',
    "Content-Type": "application/json",
    accept: "application/json",
    timezone : '+1',
    defaultlanguage : "ar"
  };
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: method,
      body: JSON.stringify(body),
      headers: HEADERS,
    })
      .then(async (response) => {
        if (response.status === 200) {
          console.log("response::: in fetch",response)
          const data = await response.json();
          resolve(data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        console.log("err::: in fetch",err)
        reject(err);
      });
  });
}
function FETCH_GET_PROMISE(url) {
  const HEADERS = {
    Authorization: sessionStorage.getItem("authToken") || 'na',
    "Content-Type": "application/json",
    accept: "application/json",
    timezone : '+1',
    defaultlanguage : "ar"
  };
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
      headers: HEADERS,
    })
      .then(async (response) => {
        if (response.status === 200 || response.status === 300) {
          console.log("response::: in fetch",response)
          const data = await response.json();
          resolve(data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export {
  authorizationToken,
  login,
  antifraudScript,
  subscriberDetails,
  subscriberTransactions,
  subscriptionActivation,
  unsubscribe,
  unsubscribeConfirm,
  subscriptionList,
  upgrade,
  upgradeConfirm,
  loginConfirm,
  subscriptionActivationConFirm,
  checkSubcription,
  subscribe,
  register
};
